import React, { useContext, useEffect, useState } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import img2 from '../Assets/Link → trend2.png.png';
import ContentLoader from 'react-content-loader';
import { useParams } from 'react-router-dom';
import { formatDate2, Get_Api } from '../Api_Url';
import { CountryContext } from '../Components/CountryProvider';
import RelatedImageSider from '../Components/RelatedImageSider';

function DestinationinCountryDetails() {
    const { id } = useParams();
    const { CountryName } = useContext(CountryContext);
    const [isUploading, setIsUploading] = useState(false);

    const [DestinationinCDetails, setDestinationinCDetails] = useState({});

    const GetADestinationinCountry = async () => {
        try {
            setIsUploading(true)
            const response = await Get_Api(`api/admin/GetADestinationInCountry/${id}`)
            setDestinationinCDetails(response?.data)
            setIsUploading(false)
        } catch (error) {
            setIsUploading(false)
            console.log(error)
        }
    }

    useEffect(() => {
        GetADestinationinCountry();
    }, [id]);


    return (
        <>
            <Navbar />
            <br />
            <br />
            <br />
            {isUploading ? <>
                <ContentLoader
                    width={'100%'}
                    height={'100%'}
                    viewBox="0 0 450 400"
                    backgroundColor="#f0f0f0"
                    foregroundColor="#dedede"
                >
                    <rect x="43" y="304" rx="4" ry="4" width="271" height="9" />
                    <rect x="44" y="323" rx="3" ry="3" width="119" height="6" />
                    <rect x="42" y="77" rx="10" ry="10" width="388" height="217" />
                </ContentLoader>
            </> :
                <div >
                    <div className='DestinationinC'>
                        <p>{DestinationinCDetails?.Name}</p>
                        <h2>Home » Destinations In {CountryName} » {DestinationinCDetails?.Name}</h2>
                        <br />
                        <br />
                    </div>
                    <div className='Destinationincmaincontainer'>
                        <div className='Destinationincdetils'>
                            <img src={DestinationinCDetails?.Image ? DestinationinCDetails?.Image : img2} />
                            <br />
                            <br />
                            <div className='Destinationinctext'>
                                {DestinationinCDetails?.Text}
                            </div>
                        </div>
                    </div>
                    <div className='DestinationinC'>
                        <p>Related Images</p>
                        <RelatedImageSider Destination={DestinationinCDetails} />
                    </div>
                </div>
            }
            <br />
            <br />
            <br />
            <Footer />
        </>
    )
}

export default DestinationinCountryDetails